$(function() {
  $('.acc__title').click(function(j) {
    
    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.faqtion').find('.acc__panel').not(dropDown).slideUp();
    
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
    } else {
      $(this).closest('.faqtion').find('.acc__title.open').removeClass('open');
      $(this).addClass('open');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
});